import { ForwardedRef, forwardRef, ReactNode, useContext } from 'react'
import { PortalTooltipContext } from 'ui'
import { ArtboardRef } from '../../artboard/types/refs'
import { UgeArtboardContext } from '../contexts/artboard'
import { UgeEditorContext } from '../contexts/editor'
import Board from './board'
import useAnimatedCrop from './hooks/use-animated-crop'
import { Container, Pause, Wrapper } from './style'

type Props = {
    children?: ReactNode
    isGeneratingGif?: boolean
}

const Preview = ({ children, isGeneratingGif }: Props, ref: ForwardedRef<ArtboardRef>) => {
    const { activeEditor } = useContext(UgeEditorContext)
    const { duration, paused, setPaused } = useContext(UgeArtboardContext)
    const isEditingCrop = activeEditor === 'crop'
    const isPaused = paused || isGeneratingGif
    const [crop] = useAnimatedCrop(!isEditingCrop)

    const onPause = () => {
        setPaused(!paused)
    }

    return (
        <PortalTooltipContext>
            <Container style={{ height: crop.height, width: crop.width }}>
                <Wrapper style={{ transform: `translate(${-crop.x}px, ${-crop.y}px)` }}>
                    <Board crop={crop} disabled={isEditingCrop} paused={isGeneratingGif} ref={ref} />
                    {children}
                </Wrapper>
                {duration > 0 && (
                    <Pause
                        icon={isPaused ? 'play' : 'pause'}
                        iconScale={paused ? 1.5 : 1.2}
                        inverted
                        size="medium"
                        onClick={onPause}
                    />
                )}
            </Container>
        </PortalTooltipContext>
    )
}

export default forwardRef(Preview)
